<template>
  <div
    class="navbar-bot"
  >
    <div
      id="navbar-bot-portal"
    />
  </div>
</template>
<style lang='scss' scoped>
@use '~sass' as *;

.navbar-bot {
  text-align: center;
  width: 100vw;
  position: fixed;
  bottom: 0;
  // Above Vuetify layout items (app bar and navigation drawers), whose root
  // stacking level starts at 1000. Dialog overlays keep their higher layer.
  z-index: 1006;
}
</style>
